import { useField } from "formik";
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'react-modern-modal';
import serialno from '../../serialno.png';
import alloy from '../../alloy-serial.jpg';
import carbon from '../../carbon-serial.jpg';
import { useState } from "react";

const FormikSerialNo = ({ ...props }) => {
  const [field, meta] = useField(props);
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <div className="field-container serial">
    <div className="error-container"><em>*</em>{meta.touched && meta.error && <div className="error">{meta.error}</div>}</div>
      <input
        {...field}
        {...props}
        className={meta.touched && meta.error ? "input-error" : ""}
      />
            <button type='button' className='btn-modal' onClick={handleOpen}>Where is my serial number?</button>

<Modal isOpen={isOpen} onClose={handleClose}>
  <ModalHeader>Where is my serial number?</ModalHeader>
  <ModalBody className='modal-body'>
    <img src={serialno} alt='find serial number'/>
    <img src={alloy} alt='find serial number'/>
    <img src={carbon} alt='find serial number'/>
  </ModalBody>
  <ModalFooter>
    <button onClick={handleClose}>Close</button>
  </ModalFooter>
</Modal>
      
      
    </div>
  );
};
export default FormikSerialNo;